/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { mediumMediaQuery } from '../../common/utilities/sizeHelpers';
import { RunningManIcon } from '../common/icons/runningManIcon';

const defaultTextColor = '#555555';

interface AirQualityInfoProps {
    backgroundFillColor: string;
    indexNumber: string;
    indexLabel: string;
    safetyTips: string;
}

export const SafetyTipsInfo = memo(({ 
    backgroundFillColor,
    indexNumber,
    indexLabel,
    safetyTips
}: AirQualityInfoProps) => {
    return (
        <Container>
            <Title>
                <IconWrapper>
                    <RunningManIcon 
                        backgroundFillColor={backgroundFillColor} 
                        width={34}
                        height={34}  
                    />
                </IconWrapper>
                <TitleNumber>{indexNumber}</TitleNumber>
                <TitleWord>{indexLabel}</TitleWord>
            </Title>
            <MessageContainer>
                <MessageBody>{safetyTips}</MessageBody>
            </MessageContainer>
        </Container>
    );
});

const Container = styled.div`
    display: flex;
    flex-direction: column;
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;

    @media ${mediumMediaQuery} {
        font-size: 15px;
    }
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
    width: 90%;
    align-items: center;
    font-weight: 600;
    color: #555555;
`;

const IconWrapper = styled.div`
    width: 40px;
    margin: 13px 0 0 10px;
`;

const TitleNumber = styled.div`
    padding-top: 8px;
    :after {
        content: '';
        margin: 10px 0 0 5px;
        height: 60%;
        border-right: 2px solid black;
    }
`;

const TitleWord = styled.div`
    padding: 8px 0 0 5px;
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px 0 50px;
    color: ${defaultTextColor};
    font-weight: 400;
`;

const MessageBody = styled.div`
    display: flex;
    flex-direction: row; 
`;
